import React from 'react';
import Icon from '@Theme/natucare/components/Icon/Icon';
import * as styles from './Star.module.scss';
const Star = _ref => {
  let {
    half = false,
    filled = false,
    classname,
    onClick,
    ...rest
  } = _ref;
  return /*#__PURE__*/React.createElement("div", Object.assign({
    className: `${styles.root} ${classname || ''}`,
    onClick: onClick
  }, rest), half && /*#__PURE__*/React.createElement("span", {
    className: `${styles.rootIcon} ${styles.rootIconHalf}`
  }, /*#__PURE__*/React.createElement(Icon, {
    classname: `${styles.rootIconFilled}`,
    size: {
      width: 24,
      height: 24
    },
    name: "star"
  })), /*#__PURE__*/React.createElement("span", {
    className: styles.rootIcon
  }, /*#__PURE__*/React.createElement(Icon, {
    classname: `${styles.rootIcon} ${filled ? styles.rootIconFilled : ''}`,
    size: {
      width: 24,
      height: 24
    },
    name: "star"
  })));
};
export default Star;